module.exports = __webpack_public_path__ + "static/fiji1-150x150-f20269cdbee7a836f9ce4b41471e0845.png";